//sphere
import * as THREE from 'three'
import Tween from 'root/animator/tween/tween'
import Ease from 'root/animator/tween/easing'
import { dispatchSetChanging, onMobile } from '../utils'
import { layers } from '../constants'

import moonMap from '../assets/moon.jpg'
import lightMap from '../assets/light-7.png' 

class Object7 {
    instance = new THREE.Group()
    sphere
    geometry
    material
    bglight

    dirlight

    state = {
        changing: false,
        visible: false
    }

    name = "SphereLeft"

    position = {
        visible: [ 0, 0, 0 ],
        hidden: [ -10, 0, -30 ]
    }

    constructor( scene ) {
        this.init(scene)
    }

    init( scene ) {
        this.instance.visible = false;

        this.geometry = new THREE.SphereBufferGeometry(2, 50, 50)

        this.material = new THREE.MeshPhongMaterial()
        this.material.color = new THREE.Color(0x1D1D1D)
        this.material.map = new THREE.TextureLoader().load( moonMap )
        this.material.uniforms = {
            iTime: { value: 0 },
            iResolution: { value: {
            x: window.innerWidth * window.devicePixelRatio,
            y: window.innerHeight * window.devicePixelRatio,
            }}
        };
        // this.material.onBeforeCompile = function (shader) {
        //     shader.fragmentShader = shader.fragmentShader.replace('#include <roughnessmap_fragment>',`
        //     float roughnessFactor = roughness;
        //     #ifdef USE_ROUGHNESSMAP
        //     vec4 texelRoughness = texture2D( roughnessMap, vUv );
        //     roughnessFactor *= .4 + .6 * texelRoughness.g;
        //     #endif
        //     `);
        // };
        // this.material.side = THREE.DoubleSide
        this.sphere = new THREE.Mesh( this.geometry, this.material)
        this.sphere.position.set( -2, 0, 0 )
        onMobile(() => {
            this.sphere.position.set( -2, -1.75, 0 )
        })
        this.bglight = new BgLight( this.instance )

        this.dirlight = new THREE.DirectionalLight( 0xFFFFFF, .6 )
        this.dirlight.position.set( 10, 0, -10 )

        this.instance.add( this.sphere )
        this.instance.add( this.dirlight )

        this.sphere.layers.enable(layers.BLOOM_SCENE)
        this.dirlight.layers.enable(layers.BLOOM_SCENE)

        this.instance.position.set(...this.position.hidden)
        this.instance.name = this.name

        scene.add( this.instance )
    }

    resize() {
        this.material.uniforms[ 'iResolution' ].value.x = window.innerWidth * window.devicePixelRatio;
        this.material.uniforms[ 'iResolution' ].value.y = window.innerHeight * window.devicePixelRatio;
    }

    render__moveIn() {
        this.render__move(
            this.position.hidden,
            this.position.visible,
            () => { this.state.visible = true },
            Ease.OutQuintic,
            1000
        )
    }
    render__moveOut() {
        this.render__move(
            this.position.visible,
            this.position.hidden,
            () => { this.state.visible = false },
            Ease.In
        )
    }
    render__move(from: any, to: any,  onComplete = () => {}, ease = Ease.InCubic, delay = 0, duration = 2000) {
        this.state.changing = true
        dispatchSetChanging(true, 0)
        Tween.to(from, to,
            {
                renderDelay: 10,
                delay,
                duration,
                ease: ease,
                onChange: function(context) {
                    this.instance.position.set(
                        context.value[0], context.value[1], context.value[2]
                    )
                }.bind(this),
                onComplete: function() { 
                    this.state.changing = false 
                    console.log(this.state.changing)
                    dispatchSetChanging(false, 0)
                    onComplete()
                }.bind(this)
            }
        )
    }

    render({ visible = false }) {

        if ( !this.state.changing ) {
            if ( !visible && this.state.visible ) {
                this.render__moveOut()
            } else
            if ( visible && !this.state.visible ) {
                this.render__moveIn()
            }
        }

        if (this.state.visible || visible) {
            let t = performance.now() / 1000;
            this.sphere.rotation.y = 0.25 * t;
            this.material.uniforms[ 'iTime' ].value = t;
            // cornerPass.uniforms[ 'iTime' ].value = t;
            // pointPass.update(t);
            this.instance.visible = true;
        } else {
            this.instance.visible = false;
        }
    }
}

export default Object7

class BgLight {
    geometry    = null
    material    = null
    instance    = null

    constructor(scene) {
        this.geometry = new THREE.PlaneGeometry( 5, 5, 1, 1 )
        this.material = new THREE.MeshBasicMaterial({
            transparent: true,
            opacity: .9,
            side: THREE.DoubleSide,
            depthWrite: false,
            map: new THREE.TextureLoader().load( lightMap )
        })
        this.instance = new THREE.Mesh( this.geometry, this.material )
        this.instance.position.set(-2, 0, -1)
        this.instance.layers.enable(layers.BLOOM_SCENE)
        onMobile(() => {
            this.instance.position.set( -2, -2, -1 )
        })
        scene.add( this.instance )
    }
}


